import './popup-giveup.component.ajscss';

import { MailBasketAction } from '@agent/core/basket';
import { IBasketStore } from '@agent/core/basket/basket.store';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { MailComment } from '@commons/history/history-mail/mail-comment/models/mail-comment';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { i18n } from 'i18next';
import { catchError, merge, of, reduce } from 'rxjs';

import { DisplayDeprecatedComponent, ToasterFacade } from '@contact/upgrade';

import { ModalParamBasketGiveup } from './models/popup-giveup-param';
import templateUrl from './popup-giveup.component.html';

class PopupGiveupCtrl extends DisplayDeprecatedComponent implements IComponentController {
  close: Function;
  dismiss: Function;
  resolve: Function;

  private param: ModalParamBasketGiveup;
  public comment: string;

  constructor(
    private readonly $i18next: i18n,
    private readonly toasterFacade: ToasterFacade,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly basketStore: IBasketStore
  ) {
    super();
  }

  $onInit(): void {
    this.param = this.resolve();
  }

  validate(): void {
    merge(
      ...this.param.requests.map(request =>
        this.epticaDeprecatedService
          .giveUpRequest(request.id, MailComment.toComment('BOUNCE', new Date(), this.comment), '', this.param.asAccountUuid || '')
          .pipe(
            catchError(requestId => {
              this.basketStore.dispatch(new MailBasketAction.SetError([requestId]));
              return of(undefined);
            })
          )
      )
    )
      .pipe(
        reduce((acc, v) => acc + (!!v ? 0 : 1), 0),
        ng1Destroy(this)
      )
      .subscribe(nbErrors => {
        // the end
        if (nbErrors > 0) {
          // toast error
          this.toasterFacade.alert({
            message: this.$i18next.t('agent:contact.workspace.basket.toast.error.generic_error_with_count', {
              nbErrors,
              nbMax: this.param.requests.filter(request => request.selected).length,
            }),
          });
        } else {
          // toast notification
          this.toasterFacade.notification({
            message: this.$i18next.t('agent:contact.workspace.basket.toast.giveUp.complete'),
            duration: 2000,
          });
        }
        this.close();
      });
  }

  cancel(): void {
    this.dismiss();
  }
}

export class PopupGiveup implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    // from ui-bootstrap modal
    close: '&',
    dismiss: '&',
    resolve: '&',
  } as { [binding: string]: string };
  controller = ['$i18next', 'toasterFacade', 'epticaDeprecatedService', 'basketStore', PopupGiveupCtrl];
}

export default 'popupGiveup';
